/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/build/QaChecklistGroupRow.tsx
 * FILE_ID: JOBHUB-QA-BUILD-GROUP-ROW-001
 * PURPOSE: One checklist heading inside the Build table.
 * LANDMINE: The sticky element is the td. A sticky child inside a cell is
 *      confined to that cell and never pins.
 */
import { cn } from '@quotech/tenant-shared/lib/utils'
import { useQaHoldTimer } from '../../../qa/qaHoldTimer'
import { QaDragHandle } from '../../../qa/QaDragHandle'
import { QaChecklistSectionHeader } from '../QaChecklistSectionHeader'

export function QaChecklistGroupRow({
  name,
  done,
  total,
  collapsed,
  onToggle,
  onRename,
  renaming = false,
  selected,
  onToggleSelected,
  startRename,
  onRenameStarted,
  stickyClass,
  checklistId,
  areaId,
  onLongPress,
  detail,
}: {
  name: string
  done: number
  total: number
  collapsed: boolean
  onToggle: () => void
  onRename?: (title: string) => void
  renaming?: boolean
  selected?: boolean
  onToggleSelected?: () => void
  startRename?: boolean
  onRenameStarted?: () => void
  stickyClass?: string
  checklistId?: string
  areaId?: string
  onLongPress?: () => void
  detail?: string
}) {
  const hold = useQaHoldTimer(() => onLongPress?.())
  return (
    <tr
      className="border-b border-border"
      {...(onLongPress ? hold : {})}
      onContextMenu={onLongPress ? (event) => {
        event.preventDefault()
        onLongPress()
      } : undefined}
      {...(checklistId ? {
        'data-qa-checklist-row': checklistId,
        'data-qa-checklist-name': name,
        'data-qa-checklist-area': areaId,
        'data-qa-drop': `checklist:${checklistId}`,
      } : {})}
    >
      <td colSpan={6} className={cn('p-0', stickyClass && cn('sticky z-[5] bg-muted', stickyClass))}>
        <QaChecklistSectionHeader
          title={name}
          done={done}
          total={total}
          expanded={!collapsed}
          onToggle={onToggle}
          selected={selected}
          onToggleSelected={onToggleSelected}
          onRename={onRename}
          renaming={renaming}
          startRename={startRename}
          onRenameStarted={onRenameStarted}
          detail={detail}
          drag={checklistId ? <QaDragHandle kind="checklist" id={checklistId} label={name} /> : undefined}
        />
      </td>
    </tr>
  )
}
